import { render, staticRenderFns } from "./ClinicianPatientPrograms.vue?vue&type=template&id=df631bc6&scoped=true"
import script from "./ClinicianPatientPrograms.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientPrograms.vue?vue&type=script&lang=js"
import style0 from "./ClinicianPatientPrograms.vue?vue&type=style&index=0&id=df631bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df631bc6",
  null
  
)

export default component.exports